import React from 'react';

/* Écrans chargés à la demande : chacun n'est téléchargé qu'à sa première ouverture. */
export const Modals = React.lazy(() => import('./Modals'));
export const ProfilePage = React.lazy(() => import('./Profile'));
export const LeavePage = React.lazy(() => import('./Leave'));
export const TimesheetsPage = React.lazy(() => import('./Timesheets'));
export const JiraPage = React.lazy(() => import('./Jira'));
export const TeamPage = React.lazy(() => import('./Team'));
export const ProjectsPage = React.lazy(() => import('./Projects'));
export const CrmPages = React.lazy(() => import('./Crm'));
